var _path, _path2, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRarityLegendary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3212 2.19198C13.0364 1.48152 14.9636 1.48152 16.6788 2.19198L20.4553 3.75628C22.1705 4.46674 23.5333 5.82946 24.2437 7.54466L25.808 11.3212C26.5185 13.0364 26.5185 14.9636 25.808 16.6788L24.2437 20.4553C23.5333 22.1705 22.1705 23.5333 20.4553 24.2437L16.6788 25.808C14.9636 26.5185 13.0364 26.5185 11.3212 25.808L7.54465 24.2437C5.82946 23.5333 4.46674 22.1705 3.75628 20.4553L2.19198 16.6788C1.48152 14.9636 1.48152 13.0364 2.19198 11.3212L3.75628 7.54465C4.46674 5.82946 5.82946 4.46674 7.54466 3.75628L11.3212 2.19198Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7019 19.668V7.87597H12.7019V17.844H18.4139V19.668H10.7019Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6667,
    y: 1.86667,
    width: 1.86667,
    height: 3.73333,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6667,
    y: 22.4,
    width: 1.86667,
    height: 3.73333,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4667,
    y: 1.86667,
    width: 1.86667,
    height: 3.73333,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4667,
    y: 22.4,
    width: 1.86667,
    height: 3.73333,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarityLegendary);
export default __webpack_public_path__ + "static/media/rarity-legendary.be328cca.svg";
export { ForwardRef as ReactComponent };